"use strict"

// undefined or null detail
function dataNullOrEmpty(string) {

    if (typeof string == "string") {
        string = string.trim();
    }

    if (string === null || string === "" || string === "1/1/1900" || string === "01/01/1900" || string === "//"
        || string === "Invalid date" || string === "Invalid date - Invalid date" || string === undefined || string === ", , " || string === "--select--") {
        return "NOT SPECIFIED";
    } else {
        return string;
    }
}


// undefined or null detail v2  but returns empty string
function dataNullOrEmptyV2(string) {
    if (string === null || string === "" || string === "1/1/1900" || string === "01/01/1900" || string === "//"
        || string === "Invalid date" || string === "Invalid date - Invalid date" || string === undefined || string === ", , ") {
        return "";
    } else {
        return string;
    }
}

//for checking of empty tin
function dataNullOrEmptyV3(string) {

    if (typeof string == "string") {
        string = string.trim();
    }

    string.replace(/-/g, '');
    string = stringToParseFloat(string);

    if(string === 0) {
        return "NOT SPECIFIED";
    } else {
        return string;
    }
}

function replaceStringIfMatch(string, match) {
    if (string.trim() === match.trim()) {
        return "";
    } else {
        return string;
    }
}

// Format input to currency
function formatToCurrency(number) {
    const fixedNumber = Number.parseFloat(number).toFixed(2);
    let formattedNumber = String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    formattedNumber = formattedNumber ? formattedNumber : "0.00";

    return formattedNumber;

}

// Format input to currency without rounding off
function formatToCurrencyNoRounding(number) {
    const fixedNumber = Number.parseFloat(number.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]).toFixed(2);
    let formattedNumber = String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    formattedNumber = formattedNumber ? formattedNumber : "0.00";

    return formattedNumber;

}

function formatToCurrencyFourDecimalPlaces(number) {
    let fixedNumber = (Math.floor(number * 10000) / 10000).toFixed(4);
    let numParts = fixedNumber.toString().split('.');
    let formattedNumber = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (numParts[1] ? "." + numParts[1] : "");

    return formattedNumber;
}

// Format input to decimal places
function formatToDecimalPlaces(number, decimal = 2) {
    return Number.parseFloat(number).toFixed(decimal);
}

// Format input to decimal without rounding off
function formatToDecimalNoRounding(number) {
    return Number.parseFloat(number.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]);
}

function formatToNumber(number) {
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function roundOff(n, decimals = 2) {
    return +(n).toFixed(decimals);
}

// Format to Capital Casing
String.prototype.toCapitalCasing = function () {

    //if (typeof this != "string") {
    //    return this;
    //}

    return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};

// Is Null or Empty
String.prototype.isEmptyThen = function (stringDefault = "") {

    //if (typeof this != "string") {
    //    return this;
    //}

    if (this == null || this.trim() == "") {
        return stringDefault;
    }
    else {
        return this;
    }
};

// Escapes "/[\\"']/" in string
String.prototype.addSlashes = function () {

    //if (typeof this != "string") {
    //    return this;
    //}

    //no need to do (str+'') anymore because 'this' can only be a string
    return this.replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
};

//retrieve
function toSentenceCase(a) {
    return a.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
        return match.toUpperCase();
    });
}

function validateEmail(string) {
    let email = string;
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    //returns true or false
    return re.test(email);
}

function setValueIfNull(newvalue, fields) {
    for (var i = 0; i < fields.length; i++) {
        try {
            let value = fields[i].val().trim();
            if (value.length === 0) {
                fields[i].val(newvalue);
            }
        } catch (ex) {
            //
        }

    }
}

function setValueIf(oldvalue, newvalue, fields) {
    for (i = 0; i < fields.length; i++) {
        try {
            let value = fields[i].val().trim();
            if (value === oldvalue) {
                fields[i].val(newvalue);
            }
        } catch (ex) {
            //
        }
    }
}

function returnValueIf(value, compareto, newvalue) {
    if (value === compareto) {
        return (newvalue);
    } else {
        return value;
    }
}

function tinFormat(field, num) {
    let regex = /^[0-9-]+$/;
    if (!regex.test(num)) {
        return "";
    }

    let length = num.length;

    if (length === 3 || length === 7 || length === 11) {
        num = num + "-";
    }

    if (length >= 16) {
        num = num.substring(0, 15);
        if (num.indexOf("-") >= 0) {
            if (num.match(/-/gi).length !== 3) {
                num = "";
            }
        } else {
            num = "";
        }
    }

    field.val(num);
}

function replaceDoubleQuotes(str) {
    return str.replace(/"/g, "'");
}

function padZeroes(number, length) {
    let str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }

    return str;

}

function padLeft(number, size) {
    var s = "000000" + number;
    return s.substr(s.length - size);
}

function truncate(n, useWordBoundary) {
    if (this.length <= n) { return this; }
    if (this.length === undefined || this.length === null) { return ''; }
    let subString = this.substr(0, n - 1);
    return (useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString) + htmlDecode("&hellip;");
}

function removeCommas(str = '') {
    return str.replace(',', '');
}

function nullToStringDefault(value) {
    if (value === null) {
        return "";
    } else {
        return value;
    }
}

function capitalizedString(string) {

    if (string !== undefined) {

        if (string !== '') {
            string = string.toLowerCase();
            return string.toCapitalCasing();
        } else {
            return string;
        }
        
    } else {
        return string;
    }

    //return string.toCapitalCasing();
}

function removeSpecialChars(str) {
    if (str !== null) {
        return str.replace(/[^A-Z0-9]/ig, "_");
    } else {
        return str;
    }
}

function getProviderAddress(data) {
    try {
        let address = "";

        if (data.streetaddress != "") {
            address = data.streetaddress;
        }

        if (data.cityname != "") {
            address === "" ? address = data.cityname : address = address + ", " + data.cityname;
        }

        if (data.provincename != "") {
            address === "" ? address = data.provincename : address = address + ", " + data.provincename;
        }

        return address;
    }
    catch (exception) {
        throw new Error("Check provider details given");
    }
}

function getCompleteAddress(streetaddress, cityname, provincename) {
    try {
        let address = "";

        if (streetaddress != "") {
            address = streetaddress;
        }

        if (cityname != "") {
            address === "" ? address = cityname : address = address + ", " + cityname;
        }

        if (provincename != "") {
            address === "" ? address = provincename : address = address + ", " + provincename;
        }

        return address;
    }
    catch (exception) {
        throw new Error("Check account details given");
    }
}

function convertPoundsToKilo(pounds) {
    if (pounds === "") pounds = 0;
    pounds = parseFloat(pounds);
    if (!isNaN(pounds)) {
        let kilo = pounds * 0.45359237;
        return Math.round(kilo * 100) / 100;
    } else {    
        throw new Error("The weight given is invalid.");
    }


}

function convertKiloToPounds(kilo) {
    if (kilo === "") kilo = 0;

    kilo = parseFloat(kilo);
    if (!isNaN(kilo)) {
        let pounds = kilo / 0.45359237;
        return Math.round(pounds * 100) / 100;
    } else {
        throw new Error("The weight given is invalid.");
    }


}

function convertFeetToMeter(feet, inches) {

    let error = 0;

    if (feet === "") feet = 0;
    if (inches === "") inches = 0;

    feet = parseInt(feet);
    inches = parseFloat(inches);

    if (isNaN(feet)) error++;
    if (isNaN(inches)) error++;


    if (error === 0) {
        let meter = ((feet * 12) + inches) / 39.3701;
        return Math.round(meter * 100) / 100;
        //let meter = ((feet * 12) + inches) * 0.0254;
        //return Math.round(meter * 100) / 100;
    } else {
        throw new Error("The height given is invalid.");
    }

}

function convertMeterToFeet(meter) {
    let inches, feet;

    meter = parseFloat(meter);

    if (!isNaN(meter)) {

        feet = meter * 3.28;

        inches = (feet - Math.floor(feet)) * 12;

        //inches = meter / 0.0254;
        //feet = Math.floor(inches / 12);
        //inches = inches - (feet * 12);

        return {
            //inches: Math.round(inches * 100) / 100,
            inches: Math.round(inches),
            feet: Math.floor(feet)
        };

    } else {
        throw new Error("The number given is invalid.");
    }

}

function stringToParseFloat(str) {
    if (typeof str == "string") {
        str == "" ? str = "0" : str = str;
        str = str.replace(/,/g, '');
        return parseFloat(str);
    }
    else {
        return str;
    }
}

function ordinalSuffixOf(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}

function setSelectionRange(input, selectionStart, selectionEnd) {
    if (input.setSelectionRange) {
        input.focus();
        input.setSelectionRange(selectionStart, selectionEnd);
    } else if (input.createTextRange) {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveEnd('character', selectionEnd);
        range.moveStart('character', selectionStart);
        range.select();
    }
}

function setCaretToPos(input, pos) {
    setSelectionRange(input, pos, pos);
}

function getFlooredFixed(v, d) {
    return (Math.floor(v * Math.pow(10, d)) / Math.pow(10, d)).toFixed(d);
}

function htmlDecode(input) {
    let doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}